import React, { useEffect } from 'react';
import usePagination from 'app/shared/components/desktop/pagination/pagination';
import { returnComponenet } from '../../../tools/constants';

import { useDispatch } from 'react-redux';
import ConfComponent from 'app/shared/components/common/conf-component';
import { getclaimsListBySubscriptionNumber } from 'app/modules/claim/service';

import './style.scss';

export const ContractAreaList = ({
  setInputSearch,
  cmsContractItem,
  cmsContractListe,
  contractStatusCms,
  listPage = 1,
  data = [],
  emptySearch,
  resetContractHandler,

  dataConf,
  cmsContractAndClaimtStatus,

  contractCustomerCms,
}) => {
  const dispatch = useDispatch();
  function getClaims(sub: any) {
    dispatch(getclaimsListBySubscriptionNumber(sub));
  }

  const resetContracts = () => {
    resetContractHandler();
    setInputSearch('');
  };

  const PER_PAGE = 5;

  const count = Math.ceil(data?.length / PER_PAGE);
  const _DATA = usePagination(data, PER_PAGE);

  useEffect(() => {
    _DATA.jump(listPage);
  }, [listPage, _DATA, emptySearch]);

  return (
    <div>
      {dataConf?.componentDataList?.find(e => e.componentDataKey === 'CONTRACT_PDV_ROW') &&
        _DATA.currentData().map((value, index) => {
          return (
            <div key={index}>
              <div>
                <ConfComponent
                  code="CONTRACT_PDV_ROW"
                  listCode={dataConf?.componentDataList}
                  props={{
                    cmsContractItem: { cmsContractItem },
                    cmsContractListe: { cmsContractListe },
                    contractCustomerCms,
                    items: { value },
                    cmsContractAndClaimtStatus,
                  }}
                />
              </div>
            </div>
          );
        })}
      {dataConf?.componentDataList?.find(e => e.componentDataKey === 'CONTRACT_COSTUMER_ROW') &&
        _DATA.currentData().map((value, index) => {
          return (
            <div key={index}>
              <ConfComponent
                code="CONTRACT_COSTUMER_ROW"
                listCode={dataConf?.componentDataList}
                props={{
                  cmsContractItem: { cmsContractItem },
                  cmsContractListe: { cmsContractListe },
                  contractStatusCms,
                  contractCustomerCms,
                  items: { value },
                  getClaims,
                }}
              />
            </div>
          );
        })}

      {dataConf?.componentDataList?.find(e => e.componentDataKey === 'EMPTY_AREA') &&
      emptySearch === returnComponenet['EMPTY'] &&
      data?.length === 0 ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={contractCustomerCms?.search_button?.search_button_icon?.url} height="100px" />
            <div>{contractCustomerCms?.emty_search_value_message}</div>
          </div>
        </div>
      ) : dataConf?.componentDataList?.find(e => e.componentDataKey === 'EMPTY_AREA') &&
        emptySearch === returnComponenet['FIRST'] &&
        data?.length === 0 ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={contractCustomerCms?.search_button?.search_button_icon?.url} height="100px" />
            <div>{contractCustomerCms?.first_search_message}</div>
          </div>
        </div>
      ) : dataConf?.componentDataList?.find(e => e.componentDataKey === 'EMPTY_AREA') && _DATA?.currentData()?.length === 0 ? (
        <div className={'box-info-tab-isEmpty'}>
          <div className={'info-style-tab-isEmpty'}>
            <img src={contractCustomerCms?.search_button?.search_button_icon?.url} height="100px" />

            <div>{contractCustomerCms?.empty_search_message}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};
